import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useRef } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import cx from 'clsx';
import Scrollbars from 'react-custom-scrollbars-2';
import { useTheme } from '../../ThemeProvider';
import Background from '../Background/Background';
import GithubButton from '../GithubButton/GithubButton';
import ThemeControl from '../ThemeControl/ThemeControl';
import settings from '../../settings';
import logoText from '../../assets/logo-text.svg';
import logoTextWhite from '../../assets/logo-text-white.svg';
import logo from '../../assets/logo.svg';
import appIcons from '../../assets/app-icons';
import classes from './Navbar.styles.less';
const LINK_HEIGHT = 72;
const removeTrailingSlash = (path) => path.slice(path.length - 1) === '/' ? path.slice(0, path.length - 1) : path;
const findCurrentIndex = (pathname) => settings.tools.findIndex((tool) => removeTrailingSlash(pathname) === removeTrailingSlash(tool.link));
export default function Navbar({ className }) {
    const [theme] = useTheme();
    const { pathname } = useLocation();
    const [current, setCurrent] = useState(findCurrentIndex(pathname));
    const [offline, setOffline] = useState({ ready: false, error: false });
    const scrollbars = useRef(null);
    useEffect(() => {
        const currentIndex = findCurrentIndex(pathname);
        setCurrent(currentIndex);
        if (scrollbars.current) {
            scrollbars.current.scrollTop(currentIndex * LINK_HEIGHT);
        }
    }, [pathname]);
    useEffect(() => {
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.ready
                .then(() => setOffline({ ready: true, error: false }))
                .catch(() => setOffline({ ready: false, error: true }));
        }
    }, []);
    const items = settings.tools.map((tool) => (_jsxs(NavLink, { to: tool.link, className: ({ isActive: routeIsActive }) => cx(classes.link, {
            [classes.linkActive]: routeIsActive || removeTrailingSlash(pathname) === removeTrailingSlash(tool.link),
        }), title: tool.name, children: [_jsx("img", { className: classes.icon, src: appIcons[tool.link], alt: tool.name }), _jsx("div", { className: classes.label, children: tool.name })] }, tool.name)));
    const links = settings.meta.map((link, index) => {
        const { internal, label, ...linkProps } = link;
        if (internal) {
            return (_jsx(Link, { className: classes.footerLink, to: String(linkProps.to), children: label }, index));
        }
        return (_jsx("a", { className: classes.footerLink, href: String(linkProps.href), target: "_blank", rel: "noreferrer", children: label }, index));
    });
    return (_jsx(Background, { component: "nav", className: cx(classes.navbar, classes[theme], className), children: _jsxs("div", { className: classes.inner, children: [_jsxs("div", { className: classes.main, children: [_jsxs(Link, { to: "/", className: classes.logo, children: [_jsx("img", { className: classes.logoImage, src: theme === 'light' ? logoText : logoTextWhite, alt: "Logo" }), _jsx("img", { className: classes.logoImageSmall, src: logo, alt: "Logo" })] }), _jsx(Scrollbars, { className: classes.scrollbars, style: { width: '100%' }, ref: scrollbars, children: _jsxs("div", { className: classes.links, children: [items, _jsx("div", { className: classes.linkBackground, style: {
                                            transform: current !== -1 ? `translateY(${current * 72}px)` : 'scaleY(0)',
                                        } })] }) })] }), _jsxs("div", { className: classes.footer, children: [_jsx(ThemeControl, { className: classes.themeControl }), _jsx("div", { className: classes.footerLinks, children: links }), !offline.error && offline.ready && (_jsxs("div", { className: classes.offline, children: [_jsx("span", { className: classes.offlineSuccess, children: "\u2713 Ready to work offline" }), _jsx("span", { className: classes.offlineSeparator, children: "\u2022" }), _jsx("span", { className: classes.offlineDescription, children: "Install PWA from url bar" })] })), _jsx(GithubButton, {})] })] }) }));
}
